<script setup lang="ts">
import TBase from './TBase.vue';
import type { TypographyBaseProps } from './types';

defineOptions({
  name: 'CustomH4',
});

const props = withDefaults(defineProps<TypographyBaseProps>(), {
  fontFamily: 'BMWGroupTNC',
  size: 26,
  color: 'inherit',
  weight: 700,
  onClick: undefined,
});
</script>

<template>
  <TBase v-bind="props">
    <slot />
  </TBase>
</template>
